import { JsonapiEntity, attribute, entity } from 'jsonapi-transformers';

@entity({ type: 'languages' })
export class Language extends JsonapiEntity<Language> {
  @attribute() label: string;
  @attribute() is_default: boolean;
}
